import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailCondition({ item }) {
    const conditionDisplay = get(item, 'conditionDisplay');

    if (!conditionDisplay) {
        return null;
    }
    return <span data-tn="pdp-spec-condition">{conditionDisplay}</span>;
}

PdpSharedDetailCondition.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailCondition, {
    item: graphql`
        fragment PdpSharedDetailCondition_item on Item {
            conditionDisplay
        }
    `,
});
